
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import SettingsQrMenu from "@/components/SettingsQrMenu";

/**
 * Reporting component
 */
export default {
  page: {
    title: "SettingsMenu",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, SettingsQrMenu},

};
</script>

<template>
  <Layout>

    <div class="px-3">
        <SettingsQrMenu></SettingsQrMenu>
    </div>

  </Layout>
</template>
